import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { apiRequests } from '../../shared/api/apiRequests';
import { Availability } from '../../entities/Availability';
import { LanguageOptions } from '../../entities/LanguageOptions';
import { toast } from 'react-toastify';
import { hasChangesAvailability } from '../../shared/utils/compareAvailability.js';
import { Form, Row, Col } from 'react-bootstrap';
import { FormLayout, FormSection, FormField, FormLoading } from '../../shared/ui/FormLayout';

const EditCategoryOfPortfolioPage = () => {
  const [form, setForm] = useState(null);
  const [oldData, setOldData] = useState(null);
  const [saving, setSaving] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();

  const handleSubmit = async () => {
    if (!form.title?.trim()) { toast.error('Введите название'); return; }
    setSaving(true);
    try {
      if (hasChangesAvailability(oldData.availability, form.availability)) {
        await apiRequests.portfolio.updateAvailability(form.availability);
      }
      await apiRequests.portfolio.updateCategory(form);
      toast.success('Категория изменена');
      navigate('/portfolio/categories');
    } catch { toast.error('Ошибка'); } finally { setSaving(false); }
  };

  useEffect(() => {
    const getData = () => {
      apiRequests.portfolio.getCategory(id).then((res) => {
        setOldData(res);
        setForm(res);
      });
    };

    getData();
  }, []);

  if (!form) return <FormLoading />;

  return (
    <FormLayout onSubmit={handleSubmit} onBack={() => navigate('/portfolio/categories')} saving={saving} submitText="Сохранить">
      <FormSection title="Основная информация">
        <Row>
          <Col md={6}>
            <FormField label="Название" required>
              <Form.Control type="text" value={form.title} onChange={(e) => setForm((prev) => ({ ...prev, title: e.target.value }))} placeholder="Категория" />
            </FormField>
          </Col>
          <Col md={6}>
            <LanguageOptions initialValue={form.mainLanguageId} onSelect={(val) => setForm((prev) => ({ ...prev, mainLanguageId: val }))} />
          </Col>
        </Row>
      </FormSection>
      <FormSection title="Доступность">
        <Availability
          initialValues={form.availability}
          onSelect={(val) => setForm((prev) => ({ ...prev, availability: { ...prev.availability, availableInAllCountries: val } }))}
          onSelectAllowed={(val) => setForm((prev) => ({ ...prev, availability: { ...prev.availability, allowedCountriesIds: val } }))}
          onSelectDisallowed={(val) => setForm((prev) => ({ ...prev, availability: { ...prev.availability, disallowedCountriesIds: val } }))}
        />
      </FormSection>
    </FormLayout>
  );
};

export default EditCategoryOfPortfolioPage;
